import { api } from "./api";

/**
 * Admin authentication.
 *
 * SECURITY NOTE — JWT in localStorage:
 * This is a single-admin portfolio (Emmanuel is the only authenticated user). We use
 * localStorage for the JWT instead of an httpOnly cookie because:
 *   - The backend and frontend may live on different hosts (Kubernetes ingress with /api/*
 *     routing), which would require cross-site cookie configuration + CSRF tokens.
 *   - There is no user-generated HTML on the public site (no comments, no rich text from
 *     visitors), so the XSS surface is small.
 *   - The admin panel is the only thing protected — no PII, no payments, no sessions
 *     for end users.
 * If the app ever grows to multi-user / public form fields rendering HTML, migrate to
 * httpOnly cookies + a /api/admin/refresh endpoint and add a CSP header server-side.
 */
const TOKEN_KEY = "eupegui-admin-token";

export const auth = {
  login: async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    return data;
  },
  logout: () => localStorage.removeItem(TOKEN_KEY),
  token: () => localStorage.getItem(TOKEN_KEY),
  isAuthed: () => !!localStorage.getItem(TOKEN_KEY),
};

// Attach Authorization header automatically when present
api.interceptors.request.use((config) => {
  const t = auth.token();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) auth.logout();
    return Promise.reject(err);
  },
);
